import { useContext } from "react";
import { ScrollContext } from "../Context/ScrollContext";
import About from "./About";
import Contact from "./Contact";
import Project from "./Project";

const Home = () => {
  const { HomeRef } = useContext(ScrollContext);

  return (
    <main>
      <div id="home" className="main-content-div" ref={HomeRef}>
        <h1>David</h1>
        <h1>Guillaumant-Mergler</h1>
        <h2>Full-stack Web Developer</h2>
      </div>
      <svg
        preserveAspectRatio="none"
        style={{
          height: "100%",
          width: "100%",
          background: "none",
        }}
        viewBox="0 0 1440 74"
        className="wave"
      >
        <path
          d="M456.464 0.0433865C277.158 -1.70575 0 50.0141 0 50.0141V74H1440V50.0141C1440 50.0141 1320.4 31.1925 1243.09 27.0276C1099.33 19.2816 1019.08 53.1981 875.138 50.0141C710.527 46.3727 621.108 1.64949 456.464 0.0433865Z"
          style={{
            stroke: "none",
            fill: "var(--bg-color-secondary)",
          }}
        ></path>
      </svg>

      <About />

      <svg
        viewBox="0  127 500 23"
        preserveAspectRatio="none"
        style={{
          height: "100%",
          width: "100%",
          background: "var(--bg-color-secondary)",
        }}
        className="wave"
      >
        <path
          d="M-1.97,137.67 C208.52,175.17 185.38,90.30 514.39,148.53 L500.00,150.00 L0.00,150.00 Z"
          style={{
            stroke: "var(--bg-color-tertiary)",
            fill: "var(--bg-color-tertiary)",
          }}
        ></path>
      </svg>

      <Project />
      <svg
        viewBox="0 122 500 28"
        preserveAspectRatio="none"
        style={{
          height: "100%",
          width: "100%",
          background: "var(--bg-color-tertiary)",
        }}
        className="wave"
      >
        <path
          d="M-1.97,121.88 C343.40,204.78 289.78,48.86 625.56,188.98 L504.22,154.45 L0.00,150.00 Z"
          style={{
            stroke: "var(--bg-color-quaternary)",
            fill: "var(--bg-color-quaternary)",
          }}
        ></path>
      </svg>
      <Contact />
    </main>
  );
};

export default Home;
